// extracted by mini-css-extract-plugin
export default {"wrapper":"ApartmentPreviewView_wrapper__WpMo2","apartmentInformation":"ApartmentPreviewView_apartmentInformation__seykZ","map":"ApartmentPreviewView_map__PuqOv"};